module.exports = __webpack_public_path__ + "static/media/BS.c38137e1.svg";